import { createSelector } from 'reselect';

export const layoutSelector = (state) => state.layoutReducer;

export const selectStoreConfig = createSelector(
  [layoutSelector],
  (layout) => layout.storeConfig ?? {}
);
